const handleKeyboardDown = (event: KeyboardEvent) => {
  if (event.ctrlKey && event.key === 'n') {
    event.preventDefault();
    return true;
  }
  return false;
};

export default handleKeyboardDown;
